import { apiClient } from './client';
import type { ApiResponse } from '@/types/api.types';

// ── Types ─────────────────────────────────────────────────────────────────────

export interface OpsDashboardMetrics {
  // Job Scheduler
  failedJobs:       number;
  recurringDue:     number;
  accrualsDue:      number;
  // Workflow & Approvals
  pendingApprovals: number;
  overdueApprovals: number;
  // Posting & Integration
  failedPostings:    number;
  integrationBacklog: number;
  // Banking & Reconciliation
  unreconciledBanks: number;
  // System overview
  jobsToday:         number;
  successRateToday:  number;
  lastChecked:       string; // ISO UTC
}

// ── API client ────────────────────────────────────────────────────────────────

export const opsApi = {
  getDashboard: () =>
    apiClient
      .get<ApiResponse<OpsDashboardMetrics>>('/ops/dashboard')
      .then((r) => r.data.data),
};
